<template>
  <div class="callback">
    <Loader :text="'Logging in...'"/>
  </div>
</template>

<script>
import Loader from './Loader'
import identityHandler from '@/core/identity-handler'

export default {
  created() {
    identityHandler.mgr
      .signinRedirectCallback()
      .then(user => {
        this.$store.commit('clear')
        window.location = '/'
      })
      .catch(error => {
        console.error(error)
      })
  },
  components: {
    Loader
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Callback.vue